/**
 * Portal helper — renders children into document.body so they escape any
 * ancestor stacking/overflow contexts. Fixes the bug where the sticky/relative
 * topbar with z-index can render above modal panels (Chromium quirk with
 * fixed positioning inside flex columns with overflow-hidden).
 */
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function Portal({ children }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!mounted) return null;
  return createPortal(children, document.body);
}
